import { isDefined } from '@sgme/fp';
import { FormattedMessage } from 'react-intl';

import { BlotterDetailsField } from '@/App/Blotter/grids/details/BlotterDetailsField.tsx';
import { PremiumDetailsField } from '@/App/Blotter/grids/option/details/PremiumDetailsField.tsx';
import type { BlotterOptionEntry } from '@/store/blotter/types/BlotterOptionEntry.ts';

type Props = {
  legIndex: number;
  entry: BlotterOptionEntry;
};

export const StrategyLegFieldSet = ({ entry, legIndex }: Props) => {
  return (
    <div className="container-fluid" data-e2e="blotter-detailsPanel-leg">
      <div className="fw-bold bg-lvl3 mt-3 mb-1" data-e2e="blotter-detailsPanel-leg-productDescription">
        <FormattedMessage
          id="blotter.tab.Option.details.legTitle"
          values={{
            legIndex: legIndex + 1,
            strike: entry.strike ?? '',
            optionTypeSpecific: isDefined(entry.optionType) ? (
              <FormattedMessage
                id={`blotter.tab.Option.details.optionType.${entry.optionType}`}
                values={{
                  currency: entry.dealtCurrency ?? '???',
                }}
              />
            ) : (
              (entry.dealtCurrency ?? '?')
            ),
          }}
        />
      </div>
      <div className="row">
        <BlotterDetailsField
          labelI18NKey="blotter.tab.Option.details.dealtAmount"
          formatting="amount"
          value={entry.dealtAmount}
          currency={entry.dealtCurrency}
          valueDataE2e="blotter-detailsPanel-leg-dealtAmount"
        />
        <PremiumDetailsField
          entry={entry}
          labelDataE2e="blotter-detailsPanel-leg-premiumLabel"
          valueDataE2e="blotter-detailsPanel-leg-premiumAmount"
        />
      </div>
      <div className="row">
        <BlotterDetailsField
          singleColumn
          labelI18NKey="blotter.tab.Option.details.expiry"
          formatting="date"
          value={entry.expiry}
          valueDataE2e="blotter-detailsPanel-leg-expiryDate"
        />
      </div>
    </div>
  );
};
